import { PageLoadHookRunner } from "./core/PageLoadHookRunner.mjs";
import { NavActions } from "./nav/NavActions.mjs";
import { ScrollableVideo } from "./post/ScrollableVideo.mjs";
import { AgeValidation } from "./global/AgeValidation.mjs";

class LS {
  constructor() {
    this._loadHookRunner = new PageLoadHookRunner();
    this.loadHookRunner.hooks.push(
      new AgeValidation(),
      new NavActions(),
      new ScrollableVideo(),
    );
  }

  get loadHookRunner() {
    return this._loadHookRunner;
  }

  onPageLoad() {
    this.loadHookRunner.onPageLoad();
    console.log("Lewd.Systems Ready");
  }
}

const ls = new LS();

document.addEventListener("DOMContentLoaded", () => ls.onPageLoad());
